import { Link } from "react-router-dom";
import { PrimaryButton } from "../components/primitives";

const NotFound = () => (
  <section className="flex min-h-[70vh] items-center bg-dwc-soft px-5 pb-24 pt-40">
    <div className="mx-auto max-w-xl text-center">
      <p className="text-7xl font-black tracking-tight text-dwc-green/20">404</p>
      <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-dwc-charcoal">This Road Doesn't Exist.</h1>
      <p className="mt-3 text-sm text-dwc-charcoal/65">The page you're looking for has moved or never existed. Let's get you back on route.</p>
      <div className="mt-8 flex justify-center">
        <Link to="/" data-testid="notfound-home-link">
          <PrimaryButton testId="notfound-home-btn">Back To Home</PrimaryButton>
        </Link>
      </div>
    </div>
  </section>
);

export default NotFound;
